(() => {
  'use strict';

  const VERSION = '2026-08-17-senior-shell-v28';
  const SECTION = '.faire-dawn-header-section';
  const MOBILE = '(max-width: 989px)';
  if (window.__ddUiV28 === VERSION) return;
  window.__ddUiV28 = VERSION;

  const isMobile = () => window.matchMedia(MOBILE).matches;

  function sectionFor(node) {
    return node?.closest?.(SECTION) || document.querySelector(SECTION);
  }

  function drawerIsOpen(section) {
    const drawer = section?.querySelector('.faire-site-header__drawer');
    if (!drawer) return false;
    return drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false';
  }

  function syncMenuState() {
    const body = document.body;
    if (!body) return;
    if (!isMobile()) {
      body.classList.remove('ddv28-menu-open');
      return;
    }
    const section = document.querySelector(SECTION);
    body.classList.toggle('ddv28-menu-open', drawerIsOpen(section));
  }

  function closeDrawer(section) {
    if (!section) return;
    const drawer = section.querySelector('.faire-site-header__drawer');
    if (!drawer || !drawerIsOpen(section)) return;

    const close = section.querySelector('[data-faire-close-drawer], .faire-site-header__drawer-close');
    if (close instanceof HTMLElement) close.click();

    requestAnimationFrame(() => {
      /* Fallback only if an older injected handler failed to close the authored drawer. */
      if (drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        section.querySelectorAll('.faire-site-header__mobile-overlay.is-open').forEach(node => node.classList.remove('is-open'));
      }
      syncMenuState();
    });
  }

  function meaningfulHref(anchor) {
    const raw = String(anchor?.getAttribute('href') || '').trim();
    if (!raw || raw === '#' || raw.startsWith('javascript:')) return false;
    return true;
  }

  function handleNavigationCapture(event) {
    if (!isMobile()) return;
    const target = event.target instanceof Element ? event.target : null;
    const anchor = target?.closest('a[href]');
    if (!anchor || !meaningfulHref(anchor)) return;

    const section = sectionFor(anchor);
    if (!section || !drawerIsOpen(section)) return;

    const belongsToDrawer = Boolean(anchor.closest('.faire-site-header__drawer'));
    const belongsToSelector = Boolean(anchor.closest(
      '.faire-site-header__dropdown--locale, .faire-site-header__dropdown--currency, .faire-site-header__dropdown--b2b'
    ));
    if (!belongsToDrawer && !belongsToSelector) return;

    /* Close first; do not cancel the native link. Shopify/editor navigation remains intact. */
    closeDrawer(section);
  }

  function keepSocialBoundary(section) {
    const menu = section?.querySelector('.ddmm22');
    if (!menu) return;

    /* The only social surface allowed inside the menu is the v27 icon rail at the absolute end. */
    menu.querySelectorAll('.ddmm22__stage .ddmm22__social').forEach(node => node.remove());
    const rails = Array.from(menu.querySelectorAll(':scope > .ddmm27__social'));
    if (rails.length > 1) rails.slice(1).forEach(node => node.remove());
    const rail = rails[0];
    if (rail && rail !== menu.lastElementChild) menu.appendChild(rail);
  }

  let raf = 0;
  function queue() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      document.querySelectorAll(SECTION).forEach(keepSocialBoundary);
      syncMenuState();
    });
  }

  function start() {
    document.addEventListener('click', handleNavigationCapture, true);
    const observer = new MutationObserver(queue);
    document.querySelectorAll(SECTION).forEach(section => {
      observer.observe(section, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'aria-expanded', 'hidden', 'data-state', 'data-open']
      });
    });
    document.addEventListener('shopify:section:load', queue);
    window.matchMedia(MOBILE).addEventListener?.('change', queue);
    window.addEventListener('resize', queue, { passive: true });
    queue();
    setTimeout(queue, 120);
    setTimeout(queue, 420);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
